import { Enum } from '../../utils/enums'

export const StripeAccountStatus = Enum(
  'notConnected',
  'pendingVerification',
  'verified'
)
export type StripeAccountStatus = Enum<typeof StripeAccountStatus>
